import { render, staticRenderFns } from "./Regenerate.vue?vue&type=template&id=648e6706"
import script from "./Regenerate.vue?vue&type=script&lang=js"
export * from "./Regenerate.vue?vue&type=script&lang=js"
import style0 from "./Regenerate.vue?vue&type=style&index=0&id=648e6706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports